import PropTypes from 'prop-types';
import React from 'react';

import cls from 'classnames';

import isSameDay from 'date-fns/isSameDay';

import FormattedDate from '@ott/formatted-date';
import KM from '@ott/utility-km';

import styles from './QuickTags.scss';

QuickTags.propTypes = {
  onFromSelect: PropTypes.func.isRequired,
  onToSelect: PropTypes.func.isRequired,
  onStartDateSelect: PropTypes.func.isRequired,
  destinations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      country: PropTypes.string,
      countryId: PropTypes.number,
      popularity: PropTypes.number,
      trans: PropTypes.string,
      countryCode: PropTypes.number,
    })
  ),
  /** Обычно это сегодня завтра послезавтра */
  dateTags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      date: PropTypes.instanceOf(Date),
    })
  ).isRequired,
  /** Нужно чтобы мы не показывали теги дат, которые уже в инпуте */
  startDate: PropTypes.instanceOf(Date),
  showToTags: PropTypes.bool,
  showDateTags: PropTypes.bool,
  childrenClassNames: PropTypes.object,
};

function QuickTags(props) {
  const {
    onFromSelect,
    onToSelect,
    onStartDateSelect,
    destinations,
    showToTags,
    showDateTags,
    startDate,
    childrenClassNames = {},
    dateTags,
  } = props;

  const handleTagClick = (prop, onClick, kmEvent) => {
    KM(kmEvent);
    onClick(prop);
  };

  const renderTag = (destination, onClick, kmEvent) => {
    return (
      <div
        className={styles.searchTag}
        onClick={() => handleTagClick(destination, onClick, kmEvent)}
        key={destination.id}
      >
        {destination.name}
      </div>
    );
  };

  const renderTagWithDate = (dateTag, onClick) => {
    const { title, date } = dateTag;

    return (
      <div
        className={styles.searchTag}
        onClick={() => handleTagClick(dateTag.date, onClick, 'quick_tags_date')}
      >
        {title}
        <FormattedDate className={styles.tagDate} date={date} isShortMonth={true} />
      </div>
    );
  };

  const filteredDateTags = dateTags
    .filter((dateTag) => !isSameDay(dateTag.date, startDate))
    .slice(0, 2);

  return (
    <div className={cls(styles.searchTags, childrenClassNames.searchTags)}>
      <div
        className={cls(
          styles.tagsWrapper,
          childrenClassNames.tagsWrapper,
          childrenClassNames.fromTags
        )}
      >
        {destinations.map((destination) =>
          renderTag(destination, onFromSelect, 'quick_tags_from_city')
        )}
      </div>
      {showToTags && (
        <div
          className={cls(
            styles.tagsWrapper,
            childrenClassNames.tagsWrapper,
            childrenClassNames.toTags
          )}
        >
          {[...destinations]
            .reverse()
            .map((destination) => renderTag(destination, onToSelect, 'quick_tags_to_city'))}
        </div>
      )}
      {showDateTags && (
        <div
          className={cls(
            styles.tagsWrapper,
            childrenClassNames.tagsWrapper,
            childrenClassNames.dateTags
          )}
        >
          {filteredDateTags.map((dateTag) => renderTagWithDate(dateTag, onStartDateSelect))}
        </div>
      )}
    </div>
  );
}

export default QuickTags;
